export default "__VITE_ASSET__586904a2__"